// NOTE: Commented-out code to (temporarily) disable editing due for security reasons

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import {
  useConsumerQuery,
  useConsumerStatusSummaryQuery,
} from 'apollo/queries/autogenerate/hooks';
import { HoukatsuStatus } from 'apollo/queries/autogenerate/schemas';
import Button from 'shared/modules/common/components/atoms/Button';
import TextInput from 'shared/modules/common/components/atoms/TextInput';

type Props = {
  onEditButtonPress: () => void;
};

const UserAddress = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const isHugeScreen = useMediaQuery({ minWidth: 1024 });

  const { data: consumerData } = useConsumerQuery({
    fetchPolicy: 'cache-only',
  });
  const { data: consumerStatusData } = useConsumerStatusSummaryQuery({
    fetchPolicy: 'cache-only',
  });

  const isPlus =
    consumerStatusData?.houkatsuStatus.status === HoukatsuStatus.APPROVED ||
    consumerStatusData?.houkatsuStatus.status ===
      HoukatsuStatus.APPROVED_FOR_NLP;

  const address = consumerData?.consumer.address;
  const noAddress =
    !address ||
    !Object.keys(address)
      .reduce((acc, place) => {
        return acc + place;
      }, '')
      .trim();

  const NonEditableField = (fieldProps: { label: string; value: string }) => (
    <TextInput
      value={fieldProps.value}
      label={fieldProps.label}
      editable={false}
      style={[style.textInput, isHugeScreen && style.textInputHugeScreen]}
      inputStyle={style.textInputNativeInput}
    />
  );

  return (
    <>
      <View style={[style.title, style.row, style.rowSpaceBetween]}>
        <Text style={style.titleText}>現住所</Text>
        {!noAddress && !isPlus && (
          <Button
            title="編集"
            variant="outlined"
            onPress={props.onEditButtonPress}
            style={style.editButton}
            id="edit-user-address-button"
          />
        )}
      </View>
      {noAddress && !isPlus && (
        <Button
          title="追加"
          onPress={props.onEditButtonPress}
          style={isBigScreen && style.addButton}
          id="edit-empty-user-address-button"
        />
      )}
      {!noAddress && (
        <>
          <View style={isHugeScreen && style.row}>
            <NonEditableField
              value={address?.line1 || ''}
              label="建物名・部屋番号"
            />
            <NonEditableField value={address?.line2 || ''} label="丁目・番地" />
          </View>
          {isHugeScreen && <View style={style.separator} />}
          <View style={isHugeScreen && style.row}>
            <NonEditableField value={address?.city || ''} label="市区町村" />
            <NonEditableField value={address?.state || ''} label="都道府県" />
          </View>
          {isHugeScreen && <View style={style.separator} />}
          <NonEditableField value={address?.zip || ''} label="郵便番号" />
        </>
      )}
    </>
  );
};

const style = StyleSheet.create({
  title: {
    marginBottom: 16,
  },
  titleText: {
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowSpaceBetween: {
    justifyContent: 'space-between',
  },
  separator: {
    height: 24,
  },
  textInput: {
    marginBottom: 12,
  },
  textInputHugeScreen: {
    width: '100%',
    maxWidth: 280,
    marginRight: 24,
    flexGrow: 0,
  },
  textInputNativeInput: {
    color: '#2A2E32',
  },
  editButton: {
    height: 32,
    width: 88,
  },
  addButton: {
    maxWidth: 296,
  },
});

export default UserAddress;
